// src/app/services/version.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AppVersion {
  version: string;
  displayVersion?: string;
  buildDate: string;
  build: any;
}

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private versionUrl = 'assets/version.json';

  constructor(private http: HttpClient) {}

  getVersion(): Observable<AppVersion> {
    return this.http.get<AppVersion>(this.versionUrl);
  }
}
